import React from 'react';
import { PrintContent } from '../../../components/PrintContent';
import { formatCurrency } from '../../../utils/formatNumber';
import { Status } from './Status';

const columnConfiguration = {
  columns: [
    {
      label: 'Nº do pedido',
      ref: 'id',
      format: (data: any) => `#${data.id}`,
    },
    {
      label: 'Produto',
      ref: 'name',
    },
    {
      label: 'Quantidade',
      ref: 'amount',
      format: (data: any) => {
        const { amount } = data;
        return `${parseInt(amount, 10)} un.`;
      },
    },
    {
      label: 'Valor total',
      ref: 'price',
      format: (item: any) => {
        return formatCurrency(item.price);
      },
    },
    {
      label: 'Status',
      ref: 'status',
      format: (data: any) => {
        const { status } = data;
        const noop = () => ({});
        return <Status type={Number(status)} onFinish={noop} />;
      },
    },
  ],
};

interface PritableContentProps {
  data: any[];
}

export const PritableContent: React.FC<PritableContentProps> = ({ data }) => {
  return <PrintContent data={data} body={columnConfiguration} type="simple" />;
};
